import {
    getByLastTrackingRouteLoading,
    getByLastTrackingRouteSuccess,
    getByLastTrackingRouteReject,
    getByLastTrackingRouteRequest
} from "../../actions/home/getByLastRoute";

export const getByLastRoute = (formData) => async (dispatch, getState) => {
    dispatch(getByLastTrackingRouteLoading());
    try {
        const { data } = await getByLastTrackingRouteRequest(formData, getState);
        dispatch(getByLastTrackingRouteSuccess(data))
    } catch (error) {
        dispatch(getByLastTrackingRouteReject(error))
    }
    return Promise.resolve();
};

export const cleanLastRoute = () => async (dispatch, getState) => {
    dispatch(getByLastTrackingRouteReject({}))
}